import { useEffect, useRef } from 'react';

// Taken from https://usehooks.com/usePrevious/

const usePrevious = value => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export default usePrevious;
